import { PanelItem } from '../panel-item.class';
import { Vertex3 } from '../../../spatial-classes';

export const getOffsetsCfn = (panelItem: PanelItem): { item: Vertex3, cutout: Vertex3 } => {
	const itemSize = panelItem.size;
	const cutoutSize = panelItem.cutout;

	const item = new Vertex3({ dataIn: {
		x: panelItem.center.x - (itemSize.width / 2),
		y: panelItem.center.y - (itemSize.height / 2),
		z: panelItem.center.z + (itemSize.depth / 2)
	}});

	const cutout = new Vertex3({ dataIn: {
		x: panelItem.center.x - (cutoutSize.width / 2),
		y: panelItem.boundTop
			? panelItem.center.y + (itemSize.height / 2) - cutoutSize.height
			: panelItem.center.y - (cutoutSize.height / 2),
		z: panelItem.center.z - (itemSize.depth / 2) + (cutoutSize.depth) + panelItem.item.distanceFrontOfFace
	}});

	return { item, cutout };
};
